var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckedTimeSlot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 2.5C5.35786 2.5 2 5.85786 2 10C2 14.1421 5.35786 17.5 9.5 17.5C13.6421 17.5 17 14.1421 17 10C17 5.85786 13.6421 2.5 9.5 2.5ZM0 10C0 4.75329 4.25329 0.5 9.5 0.5C14.7467 0.5 19 4.75329 19 10C19 15.2467 14.7467 19.5 9.5 19.5C4.25329 19.5 0 15.2467 0 10Z",
    fill: "#6AC7BD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 9.5,
    cy: 10,
    r: 5.5,
    fill: "#6AC7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckedTimeSlot);
export default __webpack_public_path__ + "static/media/circle-checked-time-slot.1c5e963eb7f6d4bff443303b4e5217e9.svg";
export { ForwardRef as ReactComponent };